
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about/creator/interview-matt",
      function () {
        return require("private-next-pages/about/creator/interview-matt.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about/creator/interview-matt"])
      });
    }
  